// # Welcome animation component
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './welcome.css';

const Welcome = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isReady, setIsReady] = useState(false);
  
  // # Get redirectTo and isAdmin from location state
  const redirectTo = location.state?.redirectTo || '/dashboard';
  const isAdmin = location.state?.isAdmin || false;

  useEffect(() => {
    // # Initialize component
    const init = async () => {
      try {
        // # Add safety timeout to ensure navigation happens
        const safetyTimer = setTimeout(() => {
          console.log('Safety timeout triggered - navigating to:', redirectTo);
          navigate(redirectTo, { 
            replace: true,
            state: { 
              bypassLoading: true,
              isAuthenticated: true,
              timestamp: Date.now(),
              isProfileComplete: location.state?.isProfileComplete,
              userProfile: location.state?.userProfile,
              isAdmin
            }
          });
        }, 6000); // 6 seconds safety timeout

        // # If assets are preloaded, start immediately
        if (sessionStorage.getItem('welcomeAssetsPreloaded')) {
          setIsReady(true);
          startWelcomeSequence();
        } else {
          // # If not preloaded, load logo image
          await new Promise((resolve) => {
            const img = new Image();
            img.onload = resolve;
            img.src = '/icons/signup/logo512.png';
          });
          setIsReady(true);
          startWelcomeSequence();
        }

        // # Clean up safety timer if component unmounts
        return () => clearTimeout(safetyTimer);
      } catch (error) {
        console.warn('Failed to initialize welcome screen:', error);
        // # Proceed anyway to not block the user
        setIsReady(true);
        startWelcomeSequence();
      }
    };

    init();
  }, []);

  // # Start welcome sequence
  const startWelcomeSequence = () => {
    // # Navigate after 5 seconds - guaranteed to happen
    const navigationTimer = setTimeout(() => {
      console.log('Navigating to:', redirectTo, 'isAdmin:', isAdmin);
      navigate(redirectTo, { 
        replace: true,
        state: { 
          bypassLoading: true,
          isAuthenticated: true,
          timestamp: Date.now(),
          isProfileComplete: location.state?.isProfileComplete,
          userProfile: location.state?.userProfile,
          isAdmin
        }
      });
    }, 5000);

    // # Cleanup timer
    return () => {
      clearTimeout(navigationTimer);
    };
  };

  // # Don't render until ready
  if (!isReady) {
    return null;
  }

  return (
    <div className="welcome-container">
      <div className="welcome-content">
        <img 
          src="/icons/signup/logo512.png" 
          alt="Logo" 
          className="welcome-logo"
        />
        <div className="welcome-text-container">
          <h1 className="welcome-text">
            Welcome to
          </h1>
          <h1 className="welcome-text-highlight">
            The Egyptian Mentorship Program
          </h1>
        </div>
      </div>
    </div>
  );
};

export default Welcome;
